import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import React from 'react';

export default function DialogCrud({ 
    largura='60vw', children,loading = false, openModal = false, setOpenModal, title }) {
    return (
        <Dialog style={{ width: largura }} header={title} visible={openModal} onHide={setOpenModal.bind(this, false)}>
            {loading && <ProgressSpinner/>}
            {!loading && children}
        </Dialog>
    );
}
